<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_close"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      class="scaling-svg"
    >
      <path
        id="Fill_1"
        data-name="Fill 1"
        d="M1.214,1.811A4.725,4.725,0,0,0,1,3.5a.5.5,0,1,1-1,0q0-.014,0-.028A5.575,5.575,0,0,1,.286,1.439,2.261,2.261,0,0,1,1.051.423,2.415,2.415,0,0,1,2.5,0,2.415,2.415,0,0,1,3.949.423a2.261,2.261,0,0,1,.765,1.017A5.575,5.575,0,0,1,5,3.472Q5,3.486,5,3.5a.5.5,0,0,1-1,0,4.725,4.725,0,0,0-.214-1.689,1.266,1.266,0,0,0-.422-.577A1.425,1.425,0,0,0,2.5,1a1.425,1.425,0,0,0-.864.233A1.266,1.266,0,0,0,1.214,1.811Z"
        transform="translate(3.5 1)"
      />
      <path
        id="Fill_2"
        data-name="Fill 2"
        d="M6.5,7h-5A1.5,1.5,0,0,1,0,5.5v-4A1.5,1.5,0,0,1,1.5,0h5A1.5,1.5,0,0,1,8,1.5v4A1.5,1.5,0,0,1,6.5,7Zm-5-6a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,7,5.5v-4A.5.5,0,0,0,6.5,1Z"
        transform="translate(2 4)"
      />
      <path
        id="Fill_3"
        data-name="Fill 3"
        d="M1.5,3A1.5,1.5,0,1,1,3,1.5,1.5,1.5,0,0,1,1.5,3Zm0-2a.5.5,0,1,0,.5.5A.5.5,0,0,0,1.5,1Z"
        transform="translate(4.5 6)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LogoutIcon extends Vue {}
</script>

<style>
</style>
